import { useSelector } from 'react-redux';
import { getCurrencyConfig } from '../currencyConfig';

const useCurrency = () => {
  const currencyId = useSelector((state) => state.auth.user?.currency ?? 0);
  const config = getCurrencyConfig(currencyId);

  const format = (value) => {
    const formatter = new Intl.NumberFormat('de-DE', {
      style: 'decimal',
      minimumFractionDigits: 2,
      maximumFractionDigits: 2
    });

    if (typeof value === 'string') {
      const parsed = parseFloat(value.replace(',', ''));
      if (isNaN(parsed)) return 'parsing error';
      return formatter.format(parsed) + ' ' + config.code;
    }
    return formatter.format(Number(value)) + ' ' + config.code;
  };

  return {
    sign: config.sign,
    code: config.code,
    intlCode: config.intlCode,
    maxStake: config.maxStake,
    format
  };
};

export default useCurrency;
